import { Capacitor } from '@capacitor/core';
import 'capacitor-plugin-app-tracking-transparency';
import {
  AppTrackingStatus,
  AppTrackingTransparency,
} from 'capacitor-plugin-app-tracking-transparency';
import { useEffect, useState } from 'react';
import { FacebookEvents } from 'capacitor-facebook-events';
import * as Sentry from '@sentry/react';

export default function useTrackingPermission() {
  const [trackingPermissionStatus, setTrackingPermissionStatus] =
    useState<AppTrackingStatus>();

  useEffect(() => {
    async function requestPermission() {
      try {
        const { status } = await AppTrackingTransparency.requestPermission();
        setTrackingPermissionStatus(status);

        if (status === 'authorized') {
          FacebookEvents.setAdvertiserTrackingEnabled({ enabled: true });
          console.log('Tracking permission granted');
        } else {
          FacebookEvents.setAdvertiserTrackingEnabled({ enabled: false });
          console.log('Tracking permission denied');
        }
      } catch (e) {
        Sentry.captureException(e);
      }
    }

    const platform = Capacitor.getPlatform();

    if (platform === 'ios') {
      requestPermission();
    }
  }, []);

  return { status: trackingPermissionStatus };
}
